export default __webpack_public_path__ + "static/media/bmp.0bebb376.svg";